module.exports = __webpack_public_path__ + "static/media/downloadSpinner.1f5c616b.gif";